import { IMetadata } from './Metadata';
import { MetadataType } from './MetadataType';
import moment from 'moment';

function shouldRender(metadata: IMetadata, value: any, glyphs?: boolean) {
  // Se il valore è presente, dobbiamo mostrarlo
  if (value != null) return true;

  // I glifi per i metadati booleani vanno sempre gestiti. null == false
  if (glyphs && metadata.datatype === MetadataType.Boolean) {
    return true;
  }

  // Altrimenti saltiamo il rendering per i valori nulli in generale
  return false;
}

export function formatMetadataValue(
  metadata: IMetadata,
  value: any,
  glyphs?: boolean
) {
  if (!shouldRender(metadata, value, glyphs)) return '';

  switch (metadata.datatype) {
    case MetadataType.Boolean:
      if (glyphs) return value ? '\u{2611}' : '\u{2610}';
      return value ? 'Si' : 'No';
    case MetadataType.Currency:
      return String(value);
    case MetadataType.File:
      // TODO/HI Gestire correttamente
      return value.name as string;
    case MetadataType.Date:
      return moment(value).tz('Europe/Rome').format('DD/MM/YYYY');
    case MetadataType.Array:
      // Non dovrebbe mai essere visualizzato
      return '<Lista>';
    default:
      return String(value);
  }
}

// TODO Versione temporanea per gestire gli array con multilinea. Da gestire meglio
export function formatMetadataValueWithNewlines(
  metadata: IMetadata,
  value: any,
  glyphs?: boolean
) {
  if (!shouldRender(metadata, value, glyphs)) return '';

  if (Array.isArray(value)) {
    return value.map(v => formatMetadataValue(metadata, v, glyphs)).join('\n');
  }

  return formatMetadataValue(metadata, value, glyphs);
}
